<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='专利分配'
        :dialog="item.show"
        v-bind="$attrs"
        @on-dialog-change='dialogChange'
        max-width='450'
        persistent
      >
        <template v-slot:content>
          <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" md="12">
                  <base-marerial-user-select outlined :other-users="otherUsers" :rules="required" :disabled='item.data.status === 30' :dense='false' :multiple='false' label='撰写人' hide-details v-model="form.writerId"></base-marerial-user-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <base-marerial-user-select outlined :rules="required" :disabled='item.data.status === 30' :dense='false' :multiple='false' label='提案人(提交CPC)' hide-details v-model="form.acceptId"></base-marerial-user-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <base-marerial-user-select outlined :rules="required" :disabled='item.data.status === 30' :dense='false' :multiple='false' label='收文人(接收CPC结果)' hide-details v-model="form.authorizeId"></base-marerial-user-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <base-marerial-user-select outlined :rules="required" :disabled='item.data.status === 30' :dense='false' :multiple='false' label='后续负责人(年费跟进)' hide-details v-model="form.operateId"></base-marerial-user-select>
                </v-col>
              </v-row>

             <v-row>
                <v-col cols="12" md="12">
                  <v-select
                    :items="agenters"
                    :rules="required"
                    item-text="label"
                    item-value="value"
                    label="专利代理人"
                    outlined
                    :disabled='item.data.status === 30'
                    v-model="form.agenter"
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>

              <v-row v-if="form.writerId < 100">
                <v-col cols="12" md="12">
                  <v-menu
                    v-model="dataSelect"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        v-model="form.outWriteTimeStr"
                        label="外派日期"
                        :rules="required"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="zh-cn"
                      v-model="form.outWriteTimeStr"
                      @input="dataSelect = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>

              <v-btn color="primary" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/patent/index.js'
  import { ResetObject } from '@/utils/stringUtil.js'

  export default {
    name: 'PatentDist',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        dataSelect: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        otherUsers: [
          { id: 89, mdUserId: 'cedd0c5c18c6ce4c76a9709b21d7b020', nameDeptStr: '明邦(外部公司)', name: '明邦' },
          { id: 90, mdUserId: 'f7a86d38009c3b7a3bc31042027d14db', nameDeptStr: '阆苑双诚(外部公司)', name: '阆苑双诚' },
          { id: 91, mdUserId: '244421ddf44629b66ea34bb2c20b9cb4', nameDeptStr: '成为(外部公司)', name: '成为' },
          { id: 92, mdUserId: '133421ddf44629b66ea34bb2c20b9cb4', nameDeptStr: '冠胜(外部公司)', name: '冠胜' },
          { id: 93, mdUserId: '41003ddf44629b66ea34bb2c20b9cb4a', nameDeptStr: '水载舟(外部公司)', name: '水载舟' },
          { id: 94, mdUserId: 'd9699173357bf2ad2057ed3b09bffd48', nameDeptStr: '大象事务所(外部公司)', name: '大象事务所' },
          { id: 95, mdUserId: 'd29c7ef830a8ab04b537015d8a3f0b1b', nameDeptStr: '安徽新知汇(外部公司)', name: '安徽新知汇' },
          { id: 96, mdUserId: '7aee9958e979ce08e1c0f58610058dbc', nameDeptStr: '北京研展(外部公司)', name: '北京研展' },
          { id: 97, mdUserId: '22003ddf44629b66ea34bb2c20b9cb4f', nameDeptStr: '明礼(外部公司)', name: '明礼' },
          { id: 98, mdUserId: '28003ddf44629b66ea34bb2c20b9cb4f', nameDeptStr: '友航(外部公司)', name: '友航' },
          { id: 99, mdUserId: '28003ddf44629b66ea34bb2c20b9cb4a', nameDeptStr: '睿禾(外部公司)', name: '睿禾' }
        ],
        agenters: [
          { label: '王文利', value: '王文利' },
          { label: '陈娟', value: '陈娟' },
          { label: '李锋', value: '李锋' },
          { label: '贺彪', value: '贺彪' }
        ],
        form: {
          id: '',
          status: 5,
          writerId: '',
          acceptId: '',
          authorizeId: '',
          operateId: '',
          agenter: '',
          outWriteTimeStr: ''
        }
      }
    },
    methods: {
      save () {
        this.form.outWriteTime = new Date(this.form.outWriteTimeStr).getTime() / 1000
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
          this.form.status = this.form.status === 1 ? 5 : this.form.status
        } else {
          ResetObject(this.form)
        }
      }
    }
  }
</script>

<style lang="sass">
  #system-user-detail-page
</style>
